import { render, staticRenderFns } from "./message-video.vue?vue&type=template&id=5685d38a&scoped=true"
import script from "./message-video.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-video.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-video.vue?vue&type=style&index=0&id=5685d38a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5685d38a",
  null
  
)

export default component.exports